import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { OffsetInputComponent } from './offset-input.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    OffsetInputComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [
    OffsetInputComponent
  ],
  providers: []
})
export class OffsetInputModule {}
